export default __webpack_public_path__ + "static/home-383a3915c26095634fb473dbe7b1e470.jpg";